export default __webpack_public_path__ + "static/media/logo.42f37e5b.svg";